module.exports = __webpack_public_path__ + "static/media/manzate_super.fa3b378e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/tizon_tardio_papa/preventiva/manzate_super.png
// module id = 2017
// module chunks = 3